import { Component, OnInit, Input } from '@angular/core';
import { _ } from 'underscore';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  group
} from '@angular/animations';
import { CommercialService } from '../../commercial.service';

@Component({
  selector: 'app-cq14',
  templateUrl: './cq14.component.html',
  styleUrls: ['./cq14.component.css', '../commercial-questionnaire.component.css'],
  animations: [
    trigger('flyInOut', [
      state('in', style({
        transform: 'translateX(0)', opacity: 1
      })),
      transition('void => *', [
        style({transform: 'translateX(100px)', opacity: 0 }),
        group([
          animate('0.4s 0.1s ease', style({
            transform: 'translateX(0)',
          })),
          animate('0.4s ease', style({
            opacity: 1
          }))
        ])
      ]),
      transition('* => void', [
        group([
          animate('0.4s ease', style({
            transform: 'translateX(50px)',
          })),
          animate('0.4s 0.2s ease', style({
            opacity: 0
          }))
        ])
      ])
    ])
  ]
})
export class Cq14Component implements OnInit {
  
  @Input() data: any;
  question;
  questions;
  user_bot = false;
  userResponses = [];
  questionObj;
  deviceWidth;
  permission1_id;
  permission2_id;
  permission3_id;
  permission4_id;
  timer;
  isChecked;
  permission;
  hgPermission;
  question_sub1;
  question_sub2;
  question_sub3;
  question_sub4;
  tip;
  showTip = false;
  location_permits = [];
  tipHead;
  showTyping =  false;
  showbutton = true;
  time = 3000;

  constructor(private commercialService: CommercialService) {
    this.questions = this.commercialService.getQues();
    this.deviceWidth = this.commercialService.deviceWidth;
    this.userResponses = this.commercialService.userResponse.userResponses;
    this.hgPermission = {
      permission1: false,
      permission2: false,
      permission3: false,
      permission4: false
    };
  }

  goNext() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
    if (this.deviceWidth < 768) {
      this.timer = setTimeout(() => {
        this.next();
      }, 1000);
    }
  }

  typingNext() {
    clearTimeout(this.timer);
    if (this.deviceWidth < 768) {
      this.commercialService.unSelectService({'currentId': this.data});
      this.showTyping = true;
      this.timer = setTimeout(() => {
        this.showTyping = false;
        this.next();
      }, this.time);
    }
  }

  ngOnInit() {
    this.commercialService.currentId = this.data;
    if (this.deviceWidth < 768) {
      this.permission1_id = document.getElementById('permit1_mob');
      this.permission2_id = document.getElementById('permit2_mob');
      this.permission3_id = document.getElementById('permit3_mob');
      this.permission4_id = document.getElementById('permit4_mob');
    } else {
      this.permission1_id = document.getElementById('permit1');
      this.permission2_id = document.getElementById('permit2');
      this.permission3_id = document.getElementById('permit3');
      this.permission4_id = document.getElementById('permit4');
    }
    for (let i = 0; i < this.questions.length; i++) {
      if (this.questions[i]._id === this.data) {
        this.question = this.questions[i].com_question;
        this.questionObj = this.questions[i];
        if (this.deviceWidth > 768) {
          const question_sub1 = this.question.split('permits ');
          this.question_sub1 = question_sub1[0] + ' permits';
          const question_sub2 = question_sub1[1].split('service ');
          this.question_sub2 = question_sub2[0] + ' service';
          this.question_sub3  = question_sub2[1];
        }
      }
    }
    this.userResponses = this.commercialService.userResponse.userResponses;
    if (this.userResponses.length > 0 && !_.isEmpty(this.questionObj)) {
      const obj = _.findWhere(this.userResponses, { 'com_question_id': this.questionObj._id });
      if (!_.isEmpty(obj)) {
        this.location_permits = obj.fieldValue;
        if (!this.commercialService.addAddress && !_.isEmpty(this.location_permits)) {
          let index;
          if (this.commercialService.serialNumber !== null) {
            index = this.commercialService.serialNumber;
          } else if (this.commercialService.serialNumber === null) {
            index = 0;
          }
          if (!_.isEmpty(this.location_permits[index])) {
            this.permission = this.location_permits[index].value;
            if (!_.isEmpty(this.permission)) {
              this.isChecked = true;
              if (this.permission === 'Yes') {
                this.hgPermission = {
                  permission1: true,
                  permission2: false,
                  permission3: false,
                  permission4: false
                };
                this.permission1_id.parentElement.classList.add('active-select');
                this.tip = 'I\'m glad you got all of that taken care of!';
                this.tipHead = 'THAT\'S GREAT';
                this.showTip = true;
              } else if (this.permission === 'No, not yet') {
                this.hgPermission = {
                  permission1: false,
                  permission2: true,
                  permission3: false,
                  permission4: false
                };
                this.permission2_id.parentElement.classList.add('active-select');
                this.showTip = false;
              } else if (this.permission === 'Not necessary') {
                this.hgPermission = {
                  permission1: false,
                  permission2: false,
                  permission3: true,
                  permission4: false
                };
                this.tip = 'Just checking to make sure you\'ve covered all bases';
                this.tipHead = 'THAT\'S GREAT';
                this.showTip = true;
                this.permission3_id.parentElement.classList.add('active-select');
              } else if (this.permission === 'I need to get a permit?') {
                this.hgPermission = {
                  permission1: false,
                  permission2: false,
                  permission3: false,
                  permission4: true
                };
                this.permission4_id.parentElement.classList.add('active-select');
                this.tipHead = 'JUST AN FYI';
                this.tip = 'Each city\'s requirement is different, and my team can help point you in the right direction if need be. A good place to start is by contacting your contractor.';
                this.showTip = true;
              }
              this.user_bot = true;
              if (this.deviceWidth < 768) {
                if (this.commercialService.modifyAddress) {
                  this.typingNext();
                } else {
                  this.goNext();
                }
              }
            }
          }
        }
      }
    }


    if(!this.hgPermission.permission1 && !this.hgPermission.permission2 && !this.hgPermission.permission3 && !this.hgPermission.permission4)
    {
      this.showbutton = false;
    }

  }

  getPermission(event) {
    this.permission = event.target.value;
    this.isChecked = event.target.checked;
    if (this.isChecked === true) {
      if (this.deviceWidth < 768) {
        // // console.log.log(this.deviceWidth);
        this.commercialService.unSelectService({'currentId': this.data});
      }
      if (!_.isEmpty(this.permission)) {
        this.user_bot = true;
        if (this.permission === 'Yes') {
          this.hgPermission = {
            permission1: true,
            permission2: false,
            permission3: false,
            permission4: false
          };
          if (_.contains(this.permission2_id.parentElement.classList, 'active-select')) {
            this.permission2_id.parentElement.classList.remove('active-select');
          }
          if (_.contains(this.permission3_id.parentElement.classList, 'active-select')) {
            this.permission3_id.parentElement.classList.remove('active-select');
          }
          if (_.contains(this.permission4_id.parentElement.classList, 'active-select')) {
            this.permission4_id.parentElement.classList.remove('active-select');
          }
          this.permission1_id.parentElement.classList.add('active-select');
          this.tipHead = 'THAT\'S GREAT';
          this.tip = 'I\'m glad you got all of that taken care of!';
          this.showTip = true;
        } else if (this.permission === 'No, not yet') {
          this.hgPermission = {
            permission1: false,
            permission2: true,
            permission3: false,
            permission4: false
          };
          this.showTip = false;
          this.permission2_id.parentElement.classList.add('active-select');
          if (_.contains(this.permission1_id.parentElement.classList, 'active-select')) {
            this.permission1_id.parentElement.classList.remove('active-select');
          }
          if (_.contains(this.permission3_id.parentElement.classList, 'active-select')) {
            this.permission3_id.parentElement.classList.remove('active-select');
          }
          if (_.contains(this.permission4_id.parentElement.classList, 'active-select')) {
            this.permission4_id.parentElement.classList.remove('active-select');
          }
        } else if (this.permission === 'Not necessary') {
          this.hgPermission = {
            permission1: false,
            permission2: false,
            permission3: true,
            permission4: false
          };
          this.permission3_id.parentElement.classList.add('active-select');
          if (_.contains(this.permission1_id.parentElement.classList, 'active-select')) {
            this.permission1_id.parentElement.classList.remove('active-select');
          }
          if (_.contains(this.permission2_id.parentElement.classList, 'active-select')) {
            this.permission2_id.parentElement.classList.remove('active-select');
          }
          if (_.contains(this.permission4_id.parentElement.classList, 'active-select')) {
            this.permission4_id.parentElement.classList.remove('active-select');
          }
          this.tipHead = 'THAT\'S GREAT';
          this.tip = 'Just checking to make sure you\'ve covered all bases';
          this.showTip = true;
        } else if (this.permission === 'I need to get a permit?') {
          this.hgPermission = {
            permission1: false,
            permission2: false,
            permission3: false,
            permission4: true
          };
          this.permission4_id.parentElement.classList.add('active-select');
          if (_.contains(this.permission1_id.parentElement.classList, 'active-select')) {
            this.permission1_id.parentElement.classList.remove('active-select');
          }
          if (_.contains(this.permission3_id.parentElement.classList, 'active-select')) {
            this.permission3_id.parentElement.classList.remove('active-select');
          }
          if (_.contains(this.permission2_id.parentElement.classList, 'active-select')) {
            this.permission2_id.parentElement.classList.remove('active-select');
          }
          this.tipHead = 'JUST AN FYI';
          this.tip = 'Each city\'s requirement is different, and my team can help point you in the right direction if need be. A good place to start is by contacting your contractor.';
          this.showTip = true;
        }
        if (this.deviceWidth < 768) {
          this.goNext();
        }
      }
    } else {
      this.hgPermission = {
        permission1: false,
        permission2: false,
        permission3: false,
        permission4: false
      };
      if (_.contains(this.permission1_id.parentElement.classList, 'active-select')) {
        this.permission1_id.parentElement.classList.remove('active-select');
      }
      if (_.contains(this.permission3_id.parentElement.classList, 'active-select')) {
        this.permission3_id.parentElement.classList.remove('active-select');
      }
      if (_.contains(this.permission2_id.parentElement.classList, 'active-select')) {
        this.permission2_id.parentElement.classList.remove('active-select');
      }
      if (_.contains(this.permission4_id.parentElement.classList, 'active-select')) {
        this.permission4_id.parentElement.classList.remove('active-select');
      }
      this.permission = '';
      if (this.deviceWidth < 768) {
        this.commercialService.unSelectService({'currentId': this.data});
      }
      this.user_bot = false;
    }
    this.save();

       
    if (this.isChecked === true)
    {
      if (this.deviceWidth < 768) {
       
      }else
      {
        if(!this.showbutton)
        {
          this.next();
        }
  
      }

    }
  }

  next() {
    if (_.isEmpty(this.permission)) {
      if (this.deviceWidth < 768) {
        this.commercialService.unSelectService({'currentId': this.data});
      }
    } else {
      this.commercialService.messageService({ 'currentId': this.data });
    }
  }

  // This function is used for to save the data in DB
  save() {
    let index;
    if (this.commercialService.serialNumber === null) {
      index = this.location_permits.length;
    } else if (this.commercialService.serialNumber !== null) {
      index = this.commercialService.serialNumber;
    }
    this.location_permits[index] = { 'serialNo': index + 1, 'value': this.permission };
    const Obj = {
      'com_question_id': this.data, 'fieldName': 'permission', 'fieldValue': this.location_permits
    };
    this.commercialService.updateResponses(Obj);
  }

}
